import { render, staticRenderFns } from "./ServicesListNotConfirmed.vue?vue&type=template&id=267d6612&scoped=true&"
import script from "./ServicesListNotConfirmed.vue?vue&type=script&lang=js&"
export * from "./ServicesListNotConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d6612",
  null
  
)

export default component.exports